export default __webpack_public_path__ + "static/media/bg_landing_page.03683717.svg";